import { actions } from './data'

// Localized
// eslint-disable-next-line
export function languageChanged(locale) {
    return actions.localized.languageChanged(locale)
}



// WEBPACK FOOTER //
// ./src/features/Backend/actions.js